import React, {useEffect, useState} from "react";
import { Layout, Form, Input, Button, Row, Col, message } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import styled from "styled-components";
import { getManagerSystemInfo, editSystemInfo } from "../../http/manager";
import { useStore } from "../../store";
import { debounce } from "lodash";

const SystemInfo: React.FC = () => {
    const { systemStore } = useStore();
    const [ isEdimt, setIsEdimt ] = useState(true);
    const [form] = Form.useForm();

    useEffect(() => {
        systemInfo({});
        return;
    }, []);

    const systemInfo = (params:any)=> {
        getManagerSystemInfo(params).then((res:any)=> {
            systemStore.setSystemInfo(res.data[0]);
            systemStore.setId(res.data[0].id);
            systemStore.setCopyright(res.data[0].copyright);
            systemStore.setAddr(res.data[0].addr);
            systemStore.setLink(res.data[0].link);
            systemStore.setLinktel(res.data[0].linktel);
            systemStore.setEmail(res.data[0].email);
            form.setFieldsValue(res.data[0]);
        })
    }
    const changeEdimt = ()=> {
        setIsEdimt(!isEdimt)
    }
    const onFormFinish = (changeValue: any) => {
        const {copyright, addr, link, linktel, email} = changeValue;
        if (copyright) {
            systemStore.setCopyright(copyright);
        }
        if (addr) {
            systemStore.setAddr(addr);
        }
        if (link) {
            systemStore.setLink(link);
        }
        if (linktel) {
            systemStore.setLinktel(linktel);
        }
        if (email) {
            systemStore.setEmail(email);
        }
    }
    const toSave = ()=> {
        loginDebounce();
    }
    const save = ()=> {
        const form = new FormData();
        form.set("id", systemStore.id);
        form.set("copyright", systemStore.copyright);
        form.set("addr", systemStore.addr);
        form.set("link", systemStore.link);
        form.set("linktel", systemStore.linktel);
        form.set("email", systemStore.email);
        editSystemInfo(form).then((res: any)=> {
            if (res && res.data) {
                message.success("更新成功");
            } else {
                message.error("保存失败");
            }
        })
    }
    const loginDebounce = debounce(save, 500)
    return (
        <Layout style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding:"0 0 0 0"}}>
                <TitleSpan>系统信息</TitleSpan>
            </Header>
            <Content style={{ flex: 1, overflow: 'hidden' }}>
                <Wrapper>
                    <FormWrapper>
                        <Form 
                            form={form}
                            labelCol={{ span: 2 }}
                            wrapperCol={{ span: 12 }}
                            labelAlign={"right"}
                            disabled={isEdimt}
                            onValuesChange={ onFormFinish }
                            initialValues={{
                                copyright: systemStore.systemInfo?.copyright, 
                                addr: systemStore.systemInfo?.addr, 
                                link: systemStore.systemInfo?.link,
                                linktel: systemStore.systemInfo?.linktel,
                                email: systemStore.systemInfo?.email,
                            }}>
                            <Form.Item
                                label="版权"
                                name="copyright"
                                >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="地址"
                                name="addr"
                                >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="联系人"
                                name="link"
                                >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="联系人电话"
                                name="linktel"
                                >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="邮箱"
                                name="email"
                                >
                                <Input />
                            </Form.Item>
                        </Form>
                        <BtttonWrapper>
                            <Row style={{ width: '100%' }}>
                                <Col span={22} push={2}>
                                    <Button type="primary" style={{width: "100px"}} onClick={ changeEdimt }>编辑</Button>
                                    <Button type="primary" style={{width: "100px", marginLeft: "20px"}} onClick={ toSave } >保存</Button>
                                </Col>
                            </Row>
                        </BtttonWrapper>
                    </FormWrapper>
                </Wrapper>
            </Content>
        </Layout>
    )
}

export default SystemInfo;

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;

const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;
    .tableItemWhite{
      background: white;
    }
    .tableItemGray{
      background: #F9FAFD;
    }
    .ant-table-body {
      overflow-x: scroll !important;
    }
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar {
      width: 0px;
      height: 10px !important;
    }
  }
`;
const FormWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .ant-picker{
      width: 100%;
    }
  }
`;
const BtttonWrapper = styled.div`
  & {
    display: flex;
  }
`